import { ChevronRightIcon } from '@heroicons/react/20/solid';

export interface DocumentsListProps {
  documents: Array<{
    nom: string;
    url: string;
  }>;
  textes: {
    titre: string;
  };
}

export const DocumentsList = ({ documents, textes }: DocumentsListProps) => {
  if (documents.length === 0) return null;

  return (
    <div className="rounded-lg bg-card p-4 sm:p-6 w-full mt-8">
      <h3 className="text-sm sm:text-base font-semibold text-foreground mb-3 sm:mb-4">
        {textes.titre}
      </h3>
      <div className="grid gap-2">
        {documents.map((doc) => (
          <a
            key={doc.nom}
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs sm:text-sm text-primary hover:underline"
          >
            <ChevronRightIcon className="w-3 h-3 sm:w-4 sm:h-4" />
            {doc.nom}
          </a>
        ))}
      </div>
    </div>
  );
};
